













import Vue from 'vue'
import Component from 'vue-class-component'

import { NETWORK_STATUS_PAGE_INFORMATION } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-2-customer-website-page-information'

@Component({
  components: {}
})
class NetworkStatusHelperComponents2Header extends Vue {
  NETWORK_STATUS_PAGE_INFORMATION = NETWORK_STATUS_PAGE_INFORMATION
}

export default NetworkStatusHelperComponents2Header
